import React, { useState } from 'react';
import { Box, TextField, InputAdornment, Alert } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import LancamentosTable from '../LancamentosTable';
import { Lancamento } from '../../services/types';
import ReciboLancamentoModal from '../ReciboLancamentoModal';



interface ObraPagamentosSemComprovacaoTabProps {
    obraId: number;
    onEdit: (lancamento: Lancamento) => void;
    onAttach?: (lancamento: Lancamento) => void;
    onDelete: (lancamento: Lancamento) => void;
    refreshTrigger: number;
}

export const ObraPagamentosSemComprovacaoTab: React.FC<ObraPagamentosSemComprovacaoTabProps> = ({
    obraId,
    onEdit,
    onAttach,
    onDelete,
    refreshTrigger
}) => {
    const [filters, setFilters] = useState({
        search: '',
        startDate: '',
        endDate: ''
    });

    const [isPrintModalOpen, setIsPrintModalOpen] = useState(false);
    const [selectedLancamentoToPrint, setSelectedLancamentoToPrint] = useState<Lancamento | null>(null);

    const handlePrintReceipt = (lancamento: Lancamento) => {
        setSelectedLancamentoToPrint(lancamento);
        setIsPrintModalOpen(true);
    };

    const handleClosePrintModal = () => {
        setIsPrintModalOpen(false);
        setSelectedLancamentoToPrint(null);
    };


    // We use the LancamentosTable but we need to ensure it fetches data with the missingAttachments filter.
    // However, LancamentosTable uses getLancamentos internally via its own logic if we pass filters.
    // Wait, LancamentosTable calls getLancamentos directly. I need to update LancamentosTable to accept missingAttachments in its filters prop too.

    // Let's check LancamentosTable again.
    // It accepts `filters` prop which matches the arguments for `getLancamentos`.
    // I updated `getLancamentos` signature, so I should update `LancamentosTableProps` interface in `LancamentosTable.tsx` as well to be safe, 
    // although if it just passes the object it might work if the type allows it.
    // But `LancamentosTable` defines its own interface `LancamentosTableProps`.

    return (
        <Box sx={{ p: 2 }}>
            <Alert severity="info" sx={{ mb: 2 }}>
                Exibindo apenas lançamentos que não possuem arquivos anexados.
            </Alert>
            <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
                <TextField
                    label="Buscar"
                    variant="outlined"
                    size="small"
                    value={filters.search}
                    onChange={(e) => setFilters({ ...filters, search: e.target.value })}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                    sx={{ flexGrow: 1 }}
                />
                <TextField
                    label="Data Início"
                    type="date"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ max: "9999-12-31" }}
                    value={filters.startDate}
                    onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
                />
                <TextField
                    label="Data Fim"
                    type="date"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ max: "9999-12-31" }}
                    value={filters.endDate}
                    onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
                />
            </Box>
            <LancamentosTable
                filters={{
                    obraId: obraId,
                    search: filters.search,
                    startDate: filters.startDate,
                    endDate: filters.endDate,
                    // @ts-ignore - We will update LancamentosTable definition next
                    missingAttachments: true
                }}
                onEdit={onEdit}
                onAttach={onAttach}
                onDelete={onDelete}
                onPrintReceipt={handlePrintReceipt}
                refreshTrigger={refreshTrigger}
            />

            <ReciboLancamentoModal
                open={isPrintModalOpen}
                onClose={handleClosePrintModal}
                lancamento={selectedLancamentoToPrint}
            />

        </Box>
    );
};
